module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (!_vm.agents.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("No sales data yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.agents), function(agent, index) {
    return _c('div', {
      key: agent.name,
      staticClass: "agent-row"
    }, [_c('div', {
      staticClass: "agent-rank",
      class: {
        first: index === 0
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "agent-name"
    }, [_vm._v(_vm._s(agent.name))]), _vm._v(" "), _c('div', {
      staticClass: "agent-sales"
    }, [_vm._v(_vm._s(agent.sales))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-head"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Top Agents Per Booking")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-04f04762", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f04762"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/topAgents.vue
// module id = 3017
// module chunks = 0